import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import {
    addModelingRoleTreeItems,
    addRoleMenuFolder,
    addRoleMenuNodeWithDefaultValues,
    copyRoleMenuWithDefaultValues,
    openRoleMenuNode,
    removeMenuItemFromTree,
    removeModelingRoleTreeItem,
    setModelingRoleOrgLevelValues,
    setModelingRoleTreeField,
    expandItemTree,
    findPermissionInTree,
} from "../../../reducers/reports-modeling/userLevelSlice";
import RoleModelingBox from "../role-modeling-box";

const UserLevelRoleModelingBox = ({ selectedModelingRole, selectedRole }) => {
    const dispatch = useDispatch();

    const [searchString, setSearchString] = useState("");

    useEffect(() => {
        dispatch(
            findPermissionInTree({
                searchString,
            })
        );
    }, [searchString, dispatch]);

    useEffect(() => {
        setSearchString("");
    }, [selectedRole]);

    const handleAddTreeItems = (items) =>
        dispatch(
            addModelingRoleTreeItems({
                id: selectedModelingRole.id,
                items,
            })
        );

    const handleSetOrgLevelValues = (values) =>
        dispatch(
            setModelingRoleOrgLevelValues({
                id: selectedModelingRole.id,
                values,
            })
        );

    const handleTreeItemFieldChange = (itemPath, field, value) =>
        dispatch(
            setModelingRoleTreeField({
                id: selectedModelingRole.id,
                itemPath,
                field,
                value,
            })
        );

    const handleOpenRoleMenuNode = (itemPath) =>
        dispatch(
            openRoleMenuNode({
                id: selectedModelingRole.id,
                itemPath,
            })
        );

    const handleAddRoleMenuFolder = (activeNodePath, folderName) =>
        dispatch(
            addRoleMenuFolder({
                id: selectedModelingRole.id,
                activeNodePath,
                folderName,
            })
        );

    const handleAddRoleMenuNode = (activeNodePath, tcodes) =>
        dispatch(
            addRoleMenuNodeWithDefaultValues({
                id: selectedModelingRole.id,
                activeNodePath,
                tcodes,
            })
        );

    const handleRemoveRoleMenuNode = (activeNodePath) => {
        // removeRoleMenuNode({
        //     id: selectedRole.id,
        //     activeNodePath
        // })

        dispatch(
            removeMenuItemFromTree({
                id: selectedModelingRole.id,
                menuItemPath: activeNodePath,
            })
        );
        // removeRoleMenuNode({
        //     id: selectedRole.id,
        //     activeNodePath
        // })
    };

    const handleCopyRoleMenu = (checkedMenuItems) =>
        dispatch(
            copyRoleMenuWithDefaultValues({
                id: selectedModelingRole.id,
                menuToCopy: checkedMenuItems,
            })
        );

    const handleRemoveTreeItem = (path) =>
        dispatch(
            removeModelingRoleTreeItem({
                id: selectedModelingRole.id,
                path,
            })
        );

    const handleExpandItemTree = (path) =>
        dispatch(
            expandItemTree({
                path: path,
            })
        );

    return (
        <RoleModelingBox
            role={selectedModelingRole}
            onAddTreeItems={handleAddTreeItems}
            onSetOrgLevelValues={handleSetOrgLevelValues}
            onTreeItemFieldChange={handleTreeItemFieldChange}
            onOpenRoleMenuNode={handleOpenRoleMenuNode}
            onAddRoleMenuFolder={handleAddRoleMenuFolder}
            onAddRoleMenuNode={handleAddRoleMenuNode}
            onRemoveRoleMenuNode={handleRemoveRoleMenuNode}
            onCopyRoleMenu={handleCopyRoleMenu}
            onRemoveTreeItem={handleRemoveTreeItem}
            onExpandItemTree={handleExpandItemTree}
            searchString={searchString}
            setSearchString={setSearchString}
            disabled={selectedModelingRole?.isStandard}
        />
    );
};

UserLevelRoleModelingBox.propTypes = {
    selectedModelingRole: PropTypes.object,
    selectedRole: PropTypes.object,
};

export default UserLevelRoleModelingBox;
